import { signUp as amplifySignUp, confirmSignUp as amplifyConfirmSignUp, signIn as amplifySignIn, signOut as amplifySignOut, signInWithRedirect, resetPassword as amplifyResetPassword, confirmResetPassword as amplifyConfirmResetPassword, resendSignUpCode as amplifyResendSignUpCode, } from "aws-amplify/auth";
/**
 * Hook providing authentication actions
 * Uses Amplify v6 headless pattern for Cognito integration
 */
export function useAuth() {
    const signUp = async (email, password) => {
        const result = await amplifySignUp({
            username: email,
            password,
            options: {
                userAttributes: {
                    email,
                },
                autoSignIn: true,
            },
        });
        return {
            isSignUpComplete: result.isSignUpComplete,
            nextStep: { signUpStep: result.nextStep.signUpStep },
        };
    };
    const confirmSignUp = async (email, code) => {
        await amplifyConfirmSignUp({
            username: email,
            confirmationCode: code,
        });
    };
    const signIn = async (email, password) => {
        const result = await amplifySignIn({
            username: email,
            password,
        });
        return {
            isSignedIn: result.isSignedIn,
            nextStep: { signInStep: result.nextStep.signInStep },
        };
    };
    const signOut = async (global = false) => {
        await amplifySignOut({ global });
    };
    const signInWithGoogle = async () => {
        await signInWithRedirect({ provider: "Google" });
    };
    const signInWithApple = async () => {
        await signInWithRedirect({ provider: "Apple" });
    };
    const resetPassword = async (email) => {
        await amplifyResetPassword({ username: email });
    };
    const confirmResetPassword = async (email, code, newPassword) => {
        await amplifyConfirmResetPassword({
            username: email,
            confirmationCode: code,
            newPassword,
        });
    };
    const resendSignUpCode = async (email) => {
        await amplifyResendSignUpCode({ username: email });
    };
    return {
        signUp,
        confirmSignUp,
        signIn,
        signOut,
        signInWithGoogle,
        signInWithApple,
        resetPassword,
        confirmResetPassword,
        resendSignUpCode,
    };
}
//# sourceMappingURL=use-auth.js.map